module.exports = __webpack_public_path__ + "media/application/images/icons/items-checklist-pebble-dark-green-rgb-187b802941055059082933b50b138e96.svg";